import { render, staticRenderFns } from "./GalleryLightbox.vue?vue&type=template&id=2f668867&scoped=true&"
import script from "./GalleryLightbox.vue?vue&type=script&lang=js&"
export * from "./GalleryLightbox.vue?vue&type=script&lang=js&"
import style0 from "./GalleryLightbox.vue?vue&type=style&index=0&id=2f668867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f668867",
  null
  
)

export default component.exports